/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CheckSisenseUsertypeInput = {|
  expectedPermission?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type CheckSisenseUsertypeMutationVariables = {|
  input: CheckSisenseUsertypeInput
|};
export type CheckSisenseUsertypeMutationResponse = {|
  +checkSisenseUsertype: ?{|
    +result: ?boolean
  |}
|};
export type CheckSisenseUsertypeMutation = {|
  variables: CheckSisenseUsertypeMutationVariables,
  response: CheckSisenseUsertypeMutationResponse,
|};
*/


/*
mutation CheckSisenseUsertypeMutation(
  $input: CheckSisenseUsertypeInput!
) {
  checkSisenseUsertype(input: $input) {
    result
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CheckSisenseUsertypeInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CheckSisenseUsertypePayload",
    "kind": "LinkedField",
    "name": "checkSisenseUsertype",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CheckSisenseUsertypeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CheckSisenseUsertypeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CheckSisenseUsertypeMutation",
    "operationKind": "mutation",
    "text": "mutation CheckSisenseUsertypeMutation(\n  $input: CheckSisenseUsertypeInput!\n) {\n  checkSisenseUsertype(input: $input) {\n    result\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '334833bec5d6d23d44542f0dfd8a7dad';

module.exports = node;
